import { FLOWCODE_API_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'

const DAY = 24 * 60 * 60 * 1000
const RANGE_SUMMARY_URL = FLOWCODE_API_ENDPOINT + '/analytics/range-summary'

function fromDate(date: Date): string {
  const month = date.getMonth() + 1
  const monthStr = month < 10 ? `0${month}` : month.toString()
  const day = date.getDate()
  const dayStr = day < 10 ? `0${day}` : day.toString()
  return `${date.getFullYear()}-${monthStr}-${dayStr}`
}

export interface GetHeapTrackerSharedScanCountOptions {
  token: string
  nowDate: Date
}

/**
 * Returns the scan count of all flowcodes owned by the user or shared with the user
 * indicated by the token.
 * This is a legacy api so this is made super-specific to the current use case
 * rather than intended for reuse.
 */
export async function getHeapTrackerSharedScanCount(
  options: GetHeapTrackerSharedScanCountOptions
): Promise<number | null> {
  const startDate = new Date(+options.nowDate - 14 * DAY)

  // Params are based on recommendation by Jet:
  // https://flowcode.slack.com/archives/C01HCUDK268/p1671654566830949?thread_ts=1671647055.888979&cid=C01HCUDK268
  const params = new URLSearchParams({
    product_id: '3',
    event_type_id: '1,2',
    start_date: fromDate(startDate),
    end_date: fromDate(options.nowDate)
  }).toString()

  const response = await fetch(`${RANGE_SUMMARY_URL}?${params}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${options.token}`,
      Accept: 'application/json'
    }
  })

  const json = await response.json()
  return (json?.body?.scans as number) ?? null
}
